import { Component, OnInit, ViewChild, OnDestroy, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { StaffService } from '../staff.service';
import { LeadService } from '../../lead/lead.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

const states = ["Kingston",
  "St Andrew",
  "St Catherine",
  "Portland",
  "St Mary",
  "St Thomas",
  "Hanover",
  "St Ann",
  "St James",
  "Trelawny",
  "Clarendon",
  "Manchester",
  "St Elizabeth",
  "Westmoreland"]

const cities = ["All", "Chennai", "Dharmapuri", "Krishnagiri", "Hosur", "Dindigul", "Palani", "Erode", "Dharapuram", "Karur", "Kulittalai", "Madurai", "Nagapattinam", "Myladuthurai", "Namakkal", "Nilgiris", "Uppathy", "Coonoor", "Gudalur", "Panthalur", "Udhagamandalam", "Perambalur", "Pudukkottai", "Ramanathapuram", "Salem", "Mettur", "Sivaganga", "Thanjavur", "Theni", "Thoothukudi", "Tiruchiorappalli", "Trichy", "Tirunelveli", "Tenkasi", "Tiruvannamalai", "Arani", "Thiruvarur", "Vellore", "Vaniyambadi", "Tirupattur", "Sholinghur", "Villupuram", "Tirukoilur", "Virudhunagar", "Rajapalayam", "Sivakasi", "Thiruvallur", "Tiruvallur", "Ambathur", "Ariyallur", "Krishnagiri", "Hosur", "Tiruppur", "Coimbatore", "Pollachi", "Anaimalai", "Coimbatore(North)", "Mettupalayam", "Sulur", "Cuddalore", "Chidambaram", "Chidambaram", "Kancheepuram", "Kanniyakumari", "Nagercoil"];

const regions = ["Zone A", "Zone B", "Zone C", "Zone D"]

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit, OnDestroy {
  @ViewChild('f') staffEditForm: NgForm;
  staffType: any = [{
    id: 'True',
    name: 'Collection Staff Front End'
  }, {
    id: 'False',
    name: 'Collection Staff Back End'
  }];
  firstName = "";
  isFrontEndStaff: Boolean = false;
  staff: any = {
    isFrontEndStaff: false,
    singlePointReportingManagerId: "",
    firstName: "",
    lastName: "",
    primaryMobileNumber: "",
    customId: "",
    yCoreBankingID: "",
    baseBranchId: "",
    primaryEmail: "",
    roles: [{
      id: "",
      departmentId: "",
      designationId: ""
    }],
    remarks: ""
  }
  submitted = false;
  departments = []
  designations = []
  armWorkObj = [];
  scpWorkObj = [];
  products = [];
  buckets = [];
  basebranches = [];
  collectionStaffs: any = []
  collectionStaffBaseBranch: string = '';
  agencies = []
  state = ''
  city = [];
  city1 = [];
  getRole = [];
  showOtherRoleWork: Boolean = false;
  showARMWork: Boolean = false;
  // regions = regions
  /*cities = cities;*/
  states = states;
  regions = regions
  stafId: string;
  private sub: any;
  staffDetails: any = [];
  selectedDepartment = [];
  selectedDesignations = [];
  armScopeWork = [];
  scopeWork = [];
  deptName = [];
  role = [];
  singlePointReportingManagerId = '';
  public submittedData: any;

  constructor(private route: ActivatedRoute,
    private leadService: LeadService,
    private staffService: StaffService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    private router: Router) {
    this.toastr.setRootViewContainerRef(vcr);
    this.singlePointReportingManagerId = '';
    this.designations = [];
    this.submittedData = [];
    this.selectedDesignations = [];
    this.role = [];
    this.armWorkObj = [];
    this.scpWorkObj = [];
    this.armScopeWork = [];
    this.scopeWork = [];
    // this.staffService.fetchStates().subscribe(statesCollection => this.states = statesCollection);
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.stafId = params['id']; // (+) converts string 'id' to a number
    });

    this.leadService.fetchRegions().subscribe(
      (regions: any[]) => this.regions = regions,
      (error) => console.log(error)
    );
    // products for both scp and arm scp
    this.staffService
      .getProducts()
      .subscribe((products: any[]) => {
        this.products = products;
      },
      (error) => console.log(error));
    // bukckets list both scp and arm
    this.staffService
      .getBuckets()
      .subscribe((buckets: any[]) => this.buckets = buckets,
      (error) => console.log(error));

    this.staffService
      .getDepartmaents()
      .subscribe((departments: any[]) => this.departments = departments,
      (error) => console.log(error));

    //  get base branches for both front end and back end staff
    this.staffService
      .getBaseBranches()
      .subscribe(
      (basebranches: any[]) => this.basebranches = basebranches,
      (error) => console.log(error));

    this.staffService
      .fetchStates()
      .subscribe(stateListData => {
        this.states = stateListData;
      });


    this.staffService
      .getStaffDetails(this.stafId)
      .subscribe((staff: any[]) => {

        this.staffDetails = staff;
        this.scpWorkObj = this.staffDetails["scopeOfWork"];

        for (let i = 0; i < this.staffDetails["scopeOfWork"].length; i++) {
          let dep = { departmentId: [] }
          dep.departmentId.push(this.staffDetails["scopeOfWork"][i].departmentId)
          this.staffService.getDesignations(dep).subscribe(
            (designations: any[]) => this.scpWorkObj[i].designations = designations,
            (error) => console.log(error)
          );

          this.leadService
            .fetchCities()
            .subscribe(cities => {
              this.scpWorkObj[i]['cities'] = cities;
            });

          this.regionBasedParishforSCP("data", i);
          this.staffService
            .getSupervisor(this.staffDetails["scopeOfWork"][i].managerFirstName)
            .subscribe(result => {
              this.scpWorkObj[i]['supervisor'] = result[0];
            });
          this.staffService
            .getDepartmaents()
            .subscribe((departments: any[]) => {
              this.departments = departments
              for (let p = 0; p < this.departments.length; p++) {
                if (this.staffDetails["scopeOfWork"][i]["departmentId"] == this.departments[p]["id"]) {
                  this.staffDetails["scopeOfWork"][i]["departmentId"] = this.departments[p]["id"];
                }
              }
            },
            (error) => console.log(error));

          this.staffService
            .getProducts()
            .subscribe((products: any[]) => {
              this.products = products;
              for (let p = 0; p < this.products.length; p++) {
                if (this.staffDetails["scopeOfWork"][i]["productId"] == this.products[p]["name"]) {
                  this.staffDetails["scopeOfWork"][i]["product"] = this.products[p]["name"];
                }
              }
            },
            (error) => console.log(error));



        }
        // console.log(staff);
        this.assignDepartments(staff['roles']);
        this.staffService.getStaff(this.staffDetails.isFrontEndStaff).subscribe(
          (collectionStaffs: any[]) => {
            this.collectionStaffs = collectionStaffs;
          }, (error) => console.log(error)
        );
        // this.getCollectionStaff();
        console.log(staff['singlePointReportingManagerId']);
        this.staffDetails.singlePointReportingManagerId == staff['singlePointReportingManagerId'];
        //this.singlePointReportingManagerId = this.staffDetails.singlePointReportingManagerId;
      }, (error) => console.log(error));
    //this.addSCP();


  }

  // region based states for Scope work section
  regionBasedParishforSCP(data: any, index): void {
    this.leadService.fetchStates().subscribe(
      (states: any[]) => {
        this.scpWorkObj[index].states = states;
      },
      (error) => console.log(error)
    );
  }

  fetchCities(data: any, index): void {


    if (data.indexOf(':') > -1) {
      data = data.split(':')[1].trim();
    }
    this.leadService.fetchCities().subscribe(
      (cityList: any[]) => {
        this.scpWorkObj[index].cities = cityList;

      },
      (error) => console.log(error)
    );
  }

  onSubmit() {
    // console.log(this.selectedDepartment);
    // console.log(this.selectedDesignations);
    let staffDetails = {
      "Id": this.staffDetails.id,
      "FirstName": this.staffDetails.firstName,
      "LastName": this.staffDetails.lastName,
      "MiddleName": this.staffDetails.middleName,
      "PrimaryEMail": this.staffDetails.primaryEMail,
      "PrimaryMobileNumber": this.staffDetails.primaryMobileNumber,
      "Remarks": this.staffDetails.remarks,
      "Role": '',
      "IsBlackListed": false,
      "BaseBranchId": this.staffDetails.baseBranchId,
      "SinglePointReportingManagerId": this.staffDetails.singlePointReportingManagerId,
      "IsFrontEndStaff": false,
      "BlackListingReason": '',
      "CoreBankingID": null,
      "EmployeeID": this.staffDetails.customId,
      "IsSaveAsDraft": "false",
      "userid": "1"
    }
    staffDetails['Roles'] = [];
    // for (let p = 0; p < this.selectedDepartment.length; p++) {
    //   for (let q = 0; q < this.selectedDesignations.length; q++) {
    //     if (this.selectedDepartment[p]['id'] === this.selectedDesignations[q]['departmentId']) {
    // for (let z = 0; z < this.getRole.length; z++) {
    //  if (this.getRole[z]['departmentId'] === this.selectedDesignations[q]['departmentId']) {

    staffDetails['Roles'].push({
      'id': this.getRole[0]['id'],
      'DepartmentId': this.selectedDepartment[0]['id'],
      'DesignationId': this.selectedDesignations[0]['id']
    });
    // return;
    //  }
    //  }

    //     }
    //   }
    // }

    staffDetails['ScopeOfWork'] = [];
    if (this.scpWorkObj.length > 0) {
     
      for (let y = 0; y < this.scpWorkObj.length; y++) {         
        staffDetails['ScopeOfWork'].push({
          'id': this.scpWorkObj[y].id,
          'Bucket': this.scpWorkObj[y].bucket,
          'City': this.scpWorkObj[y].city,
          'Product': this.scpWorkObj[y].product,
          'Region': this.scpWorkObj[y].region,
          'State': this.scpWorkObj[y].state,
          'ManagerId': this.scpWorkObj[y]['supervisor']['id'],
          'DepartmentId': this.scpWorkObj[y].departmentId,
          'DesignationId': this.scpWorkObj[y].designationId,
          "IsDeleted": false
          //  'managerId':  this.scpWorkObj[y]['supervisor']['id']
        }
        );
      }
    } else {
      staffDetails['ScopeOfWork'].push({
        'id': '',
        "Bucket": "",
        "City": "",
        "Product": "",
        "Region": "",
        "State": "",
        "ManagerId": null,
        "DepartmentId": "",
        "DesignationId": "",
        "IsDeleted": false
      }
      );
    }
    
    this.staffService.postStaffEditDetails(staffDetails).subscribe(
      (response) => {
        console.log(response);

        var router = this.router;
        setTimeout(function () {
          router.navigateByUrl('/search-staff');
        }, 5000);
        this.toastr.success('User updated successfully.');
      },
      (error) => {
        this.toastr.error('User could not be updated.');
        console.log(error);
      }
    );
  }
  goToHome() {
    this.router.navigate(['/']);
  }

  assignDepartments = (roles) => {
    this.getRole = roles;
    const departments = [];
    for (let i = 0; i < roles.length; i++) {
      for (let j = 0; j < this.departments.length; j++) {
        if (this.departments[j]['id'] === roles[i]['departmentId']) {
          if (departments.indexOf(this.departments[j]) < 0) {
            departments.push(this.departments[j]);
          }
        }
      }
    }
    this.selectedDepartment = departments;
    this.assignDesignations(departments, roles);
  }

  assignDesignations(departments, designations) {
    const depts = [];
    for (let i = 0; i < departments.length; i++) {
      depts.push(departments[i]['id']);
    }
    this.staffService
      .getDesignations({ departmentId: depts })
      .subscribe(
      (result: any[]) => {
        this.designations = result;
        for (let i = 0; i < this.staffDetails.roles.length; i++) {
          for (let j = 0; j < this.designations.length; j++) {
            if (this.staffDetails.roles[i].designationId == this.designations[j]['id']) {
              this.selectedDesignations.push(this.designations[j]);
            }
          }

        }
      },
      (error) => console.log(error)
      );
  }

  assignCitiesARM = (index, state, city) => {
    this.staffService
      .fetchCities(state)
      .subscribe(cities => {
        this.armWorkObj[index]['cities'] = cities;
      });
  }

  fetchARMSOW = (arm) => {
    for (let i = 0; i < arm.length; i++) {
      const armScopeofWork = {
        id: '',
        product: '',
        bucket: '',
        state: '',
        city: '',
        agency: '',
        supervisor: ''
      };

      for (let j = 0; j < this.products.length; j++) {
        if (this.products[j]['id'] === arm[i]['product']) {
          armScopeofWork.product = this.products[j];
        };
      }

      for (let j = 0; j < this.buckets.length; j++) {
        if (this.buckets[j]['id'] === arm[i]['bucket']) {
          armScopeofWork.bucket = this.buckets[j];
        };
      }

      armScopeofWork.state = arm[i]['state'];
      armScopeofWork.city = arm[i]['city'];
      this.assignCitiesARM(i, arm[i]['state'], arm[i]['city']);
      this.fetchAgency(i, arm[i]['reportingAgencyId'], arm[i]['reportingAgencyFirstName']);
      this.fetchARMSupervisor(i, arm[i]['managerId'], arm[i]['managerFirstName']);

      this.armWorkObj.push(armScopeofWork);
    }
  }

  fetchARMSupervisor(index, id, firstName) {
    this.staffService
      .getSupervisor(firstName)
      .subscribe(result => {
        for (let i = 0; i < result.length; i++) {
          if (result[i]['id'] === id) {
            this.armWorkObj[index]['supervisor'] = result[i];
          }
        }
      });
  }

  fetchSupervisor(index, id, firstName) {
    this.staffService
      .getSupervisor(firstName)
      .subscribe(result => {
        for (let i = 0; i < result.length; i++) {
          if (result[i]['id'] === id) {
            this.scpWorkObj[index]['supervisor'] = result[i];
          }
        }
      });
  }

  fetchAgency(index, id, firstName) {
    this.staffService
      .getAgencies(firstName)
      .subscribe(result => {
        for (let i = 0; i < result.length; i++) {
          if (result[i]['id'] === id) {
            this.armWorkObj[index]['agency'] = result[i];
          }
        }
      });
  }

  fetchSOW = (sow) => {
    for (let i = 0; i < sow.length; i++) {
      const sowObj = {
        id: '',
        departmentId: '',
        designationId: '',
        product: '',
        bucket: '',
        region: '',
        state: '',
        city: '',
        supervisor: ''
      };

      for (let deptCount = 0; deptCount < this.departments.length; deptCount++) {
        if (sow[i]['departmentId'] === this.departments[deptCount]['id']) {
          sowObj.departmentId = this.departments[deptCount];
          this.assignDesignation(i, sow[i]['departmentId'], sow[i]['designationId']);
        }
      }

      for (let j = 0; j < this.products.length; j++) {
        if (this.products[j]['id'] === sow[i]['productId']) {
          sowObj.product = this.products[j];
        };
      }

      for (let j = 0; j < this.buckets.length; j++) {
        if (this.buckets[j]['id'] === sow[i]['bucket']) {
          sowObj.bucket = this.buckets[j];
        };
      }

      sowObj.region = sow[i]['region'];
      sowObj.state = sow[i]['state'];
      this.assignCity(i, sowObj.state, sow[i]['city']);
      sowObj.city = sow[i]['city'];
      this.fetchSupervisor(i, sow[i]['managerId'], sow[i]['managerFirstName']);

      this.scpWorkObj.push(sowObj);
    }
  }

  assignCity = (index, state, city) => {
    this.staffService
      .fetchCities(state)
      .subscribe(cities => {
        this.scpWorkObj[index]['cities'] = cities;
      });
  }

  getCollectionStaff() {
    this.armWorkObj = [];
    this.scpWorkObj = [];
    this.staffService.getStaff(this.staffDetails.isFrontEndStaff).subscribe(
      (collectionStaffs: any[]) => {
        this.collectionStaffs = collectionStaffs;
      },
      (error) => console.log(error)
    );
  }

  deptBasedDesignaion(data: any): void {
    const departments = { departmentId: [] }
    for (let i = 0; i < data.length; i++) {
      departments.departmentId.push(data[i]['id']);
    }
    console.log(departments);
    this.staffService
      .getDesignations(departments)
      .subscribe(
      (designations: any[]) => this.designations = designations,
      (error) => console.log(error)
      );
  }

  assignDesignation(index, department, designation) {
    let dep = { departmentId: [] }
    dep.departmentId.push(department)
    this.staffService
      .getDesignations(dep)
      .subscribe(
      (designations: any[]) => {
        this.scpWorkObj[index]['designations'] = designations;
        this.scpWorkObj[index]['designationId'] = designation;
      },
      (error) => console.log(error)
      );
  }

  // deparmanet based designation for Scope work section
  deptBasedDesignaionforSCP(data, index): void {
    let dep = { departmentId: [] }
    dep.departmentId.push(data.id)
    if (data.id == undefined) {
      dep = { departmentId: [] }
      dep.departmentId.push(data)
    }
    this.staffService.getDesignations(dep).subscribe(
      (designations: any[]) => {
        this.scpWorkObj[index].designationId ='';
         //this.scpWorkObj[index].productId = '';
        this.scpWorkObj[index].designations = designations;
      },
      (error) => console.log(error)
    );
  }

  // add arm scope of work
  addARMScope(): void {
    let armScopeofWork = {
      id: '',
      product: '',
      bucket: '',
      state: '',
      city: '',
      agency: '',
      supervisor: ''
    }
    this.armWorkObj.push(armScopeofWork);
  }

  //  add scope of work
  addSCP(): void {
    let scopeofWork = {
      id: '',
      departmentId: '',
      designationId: '',
      product: '',
      bucket: '',
      region: '',
      state: '',
      city: '',
      supervisor: '',
      designations: [],
      cities: []
    }
    this.scpWorkObj.push(scopeofWork);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .switchMap(term => this.staffService.getAgencies(term)
        .catch(() => {
          return Observable.of([]);
        }))

  formatter = (result: { firstName: string }) => result.firstName.toUpperCase();

  showAgencyResult = (result: { firstName: string }) => result.firstName.toUpperCase();

  searchSupervisor = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .switchMap(term => this.staffService.getSupervisor(term)
        .catch(() => {
          return Observable.of([]);
        }))

  formatterSupervisor = (result: { firstName: string }) => result.firstName.toUpperCase();

  supervisorResult = (result: { firstName: string }) => result.firstName.toUpperCase();

  createSinglePointManager(event, type, index) {
    for (let i = 0; i < this.scpWorkObj.length; i++) {
      let supervisorObj = this.scpWorkObj[i]['supervisor'];
      if (supervisorObj) {
        if (this.collectionStaffs.indexOf(supervisorObj) === -1) {
          this.collectionStaffs.push(supervisorObj);
        }
      }
    }
  }
  // single poiting manager
  getManager(data, type) {
    for (let i = 0; i < data.length; i++) {
      let supervisorObj = data[i]['supervisor'];
      if (supervisorObj) {
        if (this.collectionStaffs.indexOf(supervisorObj) === -1) {
          this.collectionStaffs.push(supervisorObj);
        }
      }
    }
  }

  removeSCP(index) {
    this.scpWorkObj.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/staff/edit/edit.component.ts